<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="title" :modal-id="`modal-back-list`" @close="back">
            <template v-slot:modal-body>
                <div class="p-x-4 f-regular f-c-black f-16">
                    {{ mContent }}
                </div>
            </template>
            <template v-slot:modal-footer>
                <div>
                    <SOButton
                        :outline="true"
                        :text="`Ya, batal`"
                        :full="true"
                        :id="`btn-back-list`"
                        @action="gotoCancel"
                    />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../store/state";

export default {
    name: "ModalBack",
    components: {
        SOSlotModal,
        SOButton,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.setBackLink(from.name);
            if (from.name === "mesin.edc.update") {
                vm.setTitle("Batal Ubah Mesin EDC");
                vm.setContent(
                    "Seluruh perubahan yang dilakukan tidak akan tersimpan.  Yakin ingin batal mengubah data mesin EDC?"
                );
                vm.setBackLink("mesin.edc.update");
                vm.setIdMesin(from.params.id_mesin);
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    data() {
        return {
            backLink: "mesin.edc.add",
            id_mesin: "",
            isEdit: false,
            title: "Batal Tambah Mesin EDC",
            mContent: "Yakin ingin membatalkan pembuatan mesin EDC baru?",
        };
    },
    mounted() {
        $(`#modal-back-list`).modal("show");
    },
    methods: {
        ...mapActions({
            resetPosted: `${moduleName}/resetPosted`,
        }),
        async back() {
            let pushTo = { name: this.backLink };
            if (this.id_mesin) {
                pushTo = { ...pushTo, params: { id_mesin: this.id_mesin } };
            }
            await this.$router.push(pushTo);
        },
        gotoCancel() {
            this.resetPosted();
            let pushTo = { name: "mesin.edc.list" };

            if (this.id_mesin) {
                pushTo = { name: "mesin.edc.detail", params: { id_mesin: this.id_mesin } };
            }

            this.$router.push(pushTo);
        },
        closeModal() {
            $(`#modal-back-list`).modal("hide");
        },
        setBackLink(linkName) {
            this.backLink = linkName;
        },
        setIdMesin(val) {
            this.id_mesin = val;
        },
        setTitle(title) {
            this.title = title;
        },
        setContent(content) {
            this.mContent = content;
        },
    },
};
</script>
